import { render, staticRenderFns } from "./CoozzyFileDownloadIcon.vue?vue&type=template&id=2dae6854&scoped=true"
import script from "./CoozzyFileDownloadIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFileDownloadIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFileDownloadIcon.vue?vue&type=style&index=0&id=2dae6854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae6854",
  null
  
)

export default component.exports